import { useEffect, useState } from "react";

const TikTokPlayer = (props) => {
  const [video, setVideo] = useState(props.video);

  useEffect(() => {
    if (props.video._id !== video._id) {
      const refreshVideo = setInterval(() => {
        const videoPlayer = document.getElementById("video-tiktok");
        if (videoPlayer) {
          clearInterval(refreshVideo);
        }
      }, 1000);

      setVideo(props.video);
    }
  }, [props.video, video._id]);

  return (
    <div className="text-center">
      {video && (
        <iframe
          id="video-tiktok"
          src={`https://www.tiktok.com/embed/v2/${video.tiktok_id}`}
          width="340"
          height="738px"
          frameBorder="0"
          webkitallowFullScreen
          mozallowFullScreen
          allowFullScreen
        />
      )}
    </div>
  );
};

export default TikTokPlayer;
